"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const cctvContents: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2"> Sewa CCTV Terdekat: Strategi Pengamanan Pintar Tanpa Investasi Mahal </h2>
    <h3 className="text-lg font-semibold mb-2"> Kenapa Harus Beli Kalau Bisa Sewa CCTV Terdekat yang Siap Pakai? </h3>
    <p className="mb-4"> Ketika keamanan adalah hal vital tapi dana terbatas, <strong>sewa CCTV terdekat</strong> jadi solusi cerdas. Daripada beli alat mahal yang cepat usang, cukup sewa sistem dipasang, setting dibantu, dan siap rekam 24 jam. </p>
    <ul className="space-y-4 mb-6">
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Pilih Tipe Kamera Sesuai Lokasi</h4>
        <p className="text-sm"> Indoor, outdoor, infrared, hingga IP camera resolusi tinggi semua tersedia. Tinggal sesuaikan dengan kebutuhan pengawasan. <strong>Jenis & tipe CCTV</strong> bisa kamu request langsung. Kami bantu mapping & instalasi optimal. </p>
      </li>
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Include DVR/NVR, Kabel, & Aksesori Lengkap</h4>
        <p className="text-sm"> Gak perlu beli kabel², perekam, konektor, atau hard drive tambahan. Semua sudah include dalam paket <strong>sewa CCTV terdekat</strong>. Kami pastikan sistem kamu stabil, anti gangguan sinyal, dan bisa diakses dari HP langsung. </p>
      </li>
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Gratis Antar & Instalasi Lokasi Terdekat</h4>
        <p className="text-sm"> Teknisi profesional kami siap datang ke lokasi pasang, setting view angle, bahkan bantu setting live access via internet. <strong>Sewa CCTV terdekat</strong> tanpa ribet, tanpa perlu skill teknis dari kamu. </p>
      </li>
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Cocok untuk Rumah, Gudang, Event, Toko, & Kantor</h4>
        <p className="text-sm"> Banyak klien kami menggunakan layanan <strong>sewa CCTV terdekat</strong> untuk acara besar, pengawasan gudang sementara, hingga sistem keamanan tambahan di rumah² & toko. Fleksibel, cepat, dan hemat budget. </p>
      </li>
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Harga Sewa CCTV yang Fleksibel & Transparan</h4>
        <p className="text-sm"> Mau sewa harian untuk event? Atau bulanan untuk toko ritel? Bisa. <strong>Harga sewa CCTV</strong> kami disesuaikan tipe kamera, durasi pemakaian, dan jumlah titik pantau. Kamu hanya bayar sesuai kebutuhan, tanpa biaya tersembunyi. </p>
      </li>
    </ul>
    <h2 className="text-xl font-bold mb-3">Support Brand Populer & Kamera Spesifikasi Tinggi</h2>
    <p className="mb-4"> Kami sediakan brand ternama seperti Hikvision, Dahua, Ezviz, dan Uniview. Pilihan <strong>kamera CCTV</strong> mulai dari 2MP, 5MP, hingga 4K UHD untuk kualitas detail maksimal. Dilengkapi fitur night vision, motion detection, dan koneksi cloud. </p>
    <h2 className="text-xl font-bold mb-3">Unit Selalu Dicek & Bebas Masalah Teknis</h2>
    <p className="mb-4"> Semua unit CCTV yang disewa telah lolos QC & uji coba sebelum pengiriman. <strong>Firmware dan software</strong> selalu di-update, serta dipastikan tidak ada gangguan sinyal, lag, atau file corrupt. </p>
    <h2 className="text-xl font-bold mb-3">Butuh Darurat? Sewa CCTV Bisa Langsung Kirim</h2>
    <p className="mb-4"> Keamanan gak bisa ditunda. Butuh <strong>sewa CCTV terdekat</strong> sekarang juga? Tim kami siap kirim hari itu juga, selama unit tersedia. Ideal untuk kejadian tak terduga, audit mendadak, atau kebutuhan ekstra pengawasan. </p>

    <CTA
      title="Pantau Aman Dimana² Bosku?"
      description="Klik tombol di bawah untuk booking sekarang. Cukup kirim lokasi & tanggal, kami yang urus sisanya."
      buttonText="Booking CCTV Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20cctv.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="CCTV"
    />
  </>
);
